import React from "react";
import Button from "@react/react-spectrum/Button";
import Radio from "@react/react-spectrum/Radio";
import Checkbox from "@react/react-spectrum/Checkbox";
import CoachMark from "@react/react-spectrum/CoachMark";
import Select from "@react/react-spectrum/Select";
import Link from "@react/react-spectrum/Link";
import PatternGLPipeline from '@capture/pattern-core/src/PatternGLPipeline';
import GlobalUtil from '../utils/GlobalUtil';
import Dialog from '@react/react-spectrum/Dialog';
import Wait from '@react/react-spectrum/Wait';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Tooltip from '@react/react-spectrum/Tooltip';
import close from "../Imgs/close.svg";
import { addToast, Toast } from '@react/react-spectrum/Toast';
import './DownloadCard.scss';
import LibraryManager from '../components/upload/LibraryManager';
import {connect} from 'react-redux';
import {store} from '../App';
import CaptureAnalytics from '../analytics/CaptureAnalytics';

class DownloadCard extends React.Component {

    constructor(props) {
        super(props);
        store.subscribe(() => {this.setState({libs: store.getState().libreducer.libs, libsFetched: store.getState().libreducer.libsFetched})});
    }
    state = {
        outputType: 'JPG',
        enableSaveLib: false,
        selectedlib: null,
        invalid: false,
        highRes: false,
        perviewLoaded: false,
        libs: store.getState().libreducer.libs,
        libsFetched: store.getState().libreducer.libsFetched
    }

    previewUrl = "";

    handleAddToLibrary = (dataURL) => {
        if (!this.state.enableSaveLib) {
            return;
        }
        if (!this.state.selectedlib)
        {
            this.setState({invalid: true});
            return;
        }
        const blob = GlobalUtil.dataURItoBlob(dataURL);
        const resultFile = new File([blob], 'CCH-Pattern', {'type': blob.type});
        LibraryManager.addAssettoLibrary(resultFile, this.state.selectedlib.id, this.state.selectedlib.library_urn, this.state.selectedlib.ownership,this.state.outputType === 'JPG' ? 'jpg' : 'png');
    }

    _download = (filename, url) => {
        const element = document.createElement('a');
        element.href = url;
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    _createPatternTile = () => {
        return new Promise(resolve => {
            PatternGLPipeline.process(this.props.image, true).then(dataURI => {
                resolve({
                    png: dataURI
                })
            })
        });
    }

    sendActivationAnalytic(subcategory) {
		const captureAnalytics = new CaptureAnalytics(window.ENV);
        captureAnalytics.initAnalytics();
        let eventObj;
        eventObj = {
            workflow: 'Editor Page',
            type: 'click',
            subCategory: subcategory,
            subType: 'dialog'
        };
        captureAnalytics.genericAnalyticEvent(eventObj);
	}

    getDownloadImageDimensions = () => {
        const patternName = this.props.patternName;
        let patterns = ["FourFoldReflectedFilter", "SquareFilter", "EightFoldReflectedFilter"];
        let tileW,tileH,w,h;
        if (patterns.includes(patternName)) {
            tileW = 2048;
            tileH = 2048;
        }
        else {
            tileW = 2660;
            tileH = 1536;
        }
        if (this.state.highRes) {
            tileH = tileH * 0.2;//change DPI here
            tileW = tileW * 0.2;
            w = tileW * 5;//change no of rows here
            h = tileH * 5;
            if (patterns.includes(patternName)) {
                w = tileW * 7;
                h = tileH * 5;
            }
        }
        else {
            tileH = tileH * 0.1;//change DPI here
            tileW = tileW * 0.1;
            w = tileW * 3;
            h = tileH * 5;
            if (patterns.includes(patternName)) {
                w = tileW * 5;
                h = tileH * 5;
            }
        }
        w = parseInt(w,10);
        h = parseInt(h,10);
        return [w,h];
    }

    handleImages =  (data) => {
        return new Promise(resolve => {
            const patternName = this.props.patternName;
            let patterns = ["FourFoldReflectedFilter", "SquareFilter", "EightFoldReflectedFilter"];
            const canvas = this.props.canvasRef;
            const ctx = canvas.getContext('2d');
            const img = new Image();
            img.src = data.png;
            let pngUrl = null;

            const ctxDraw =  (column,row) => {
                for (let i =0;i<row;i++) {
                    for (let j =0;j<column;j++) {
                    ctx.drawImage(img, img.width * j, img.height * i, img.width, img.height);
                    }
                }
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = "black";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            img.onload =  () => {
                if (this.state.highRes) {
                    img.width = img.width * .2;
                    img.height = img.height * .2;
                }
                else {
                    img.width = img.width * .1;
                    img.height = img.height * .1;
                }
                [canvas.width, canvas.height] = this.getDownloadImageDimensions();
                ctxDraw(8,8)
                if (this.state.outputType === "JPG") {
                    pngUrl = canvas.toDataURL("image/jpeg");
                    resolve(pngUrl);
                }
                pngUrl = canvas.toDataURL("image/png");
                resolve(pngUrl);
            }
        }); 
    }

    handleSave = () => {
        //this.sendActivationAnalytic('download');
        this._createPatternTile().then(data => {
            this.handleImages(data).then(dataURL => {
                this.handleAddToLibrary(dataURL);
                if (this.state.invalid) {
                    return;
                }
                if (this.state.outputType === "JPG") {
                    this._download('capture-pattern.jpg', dataURL);
                    this.props.onClose();
                }
                else {
                    this._download('capture-pattern.png', dataURL);
                    this.props.onClose();
                }
            });
        })
    }

    handlePreview = () => {
        this._createPatternTile().then(data => {
            this.handleImages(data).then(dataURL => {
                const blob = GlobalUtil.dataURItoBlob(dataURL);
                const resultFile = new File([blob], 'preview');
                this.previewUrl = URL.createObjectURL(resultFile);
                this.setState({perviewLoaded: true})
            })
        })
    }
    
    componentDidMount() {
        this.handlePreview();
        this.setState({libs: store.getState().libreducer.libs});
    }

    render() {
        return (
            <div className="downloadDialogWrapper"><Dialog>
            <div className="downloadDialog">
                <h1>Download your pattern</h1>
                <div className="leftSection">
                    <p>Select file type</p>
                    <div className="selection">
                        <span>
                            <Radio
                            label="JPG"
                            checked={this.state.outputType === 'JPG'}
                            onChange={() => {
                                this.setState({outputType: 'JPG'});
                                this.sendActivationAnalytic('JPG');
                            }}
                            />
                        </span>
                        <OverlayTrigger
                            disabled={window.adobeIMS.isSignedInUser() !== undefined}
                            placement="right"
                            trigger={['hover','focus']}>
                            <span style={{width: '25%'}}>
                                <Radio
                                label="PNG"
                                checked={this.state.outputType === 'PNG'}
                                disabled={window.adobeIMS.isSignedInUser() === undefined}
                                onChange={() => {
                                    this.setState({outputType: 'PNG'});
                                    this.sendActivationAnalytic('PNG');
                                }}/>
                            </span>
                            <Tooltip
                                open
                                className="qaToolTip"
                                placement="right"
                                role="tooltip"
                                variant="inspect">
                                Sign in for PNG download
                            </Tooltip>
                        </OverlayTrigger>
                    </div>
                    <p>Select file size</p>
                    <div className="selection">
                        <span>
                            <Radio
                            label="Standard resolution"
                            checked={!this.state.highRes}
                            onChange={() => {
                                this.setState({highRes: false});
                                this.sendActivationAnalytic('Standard Resolution');
                            }}/>
                        </span>
                        <OverlayTrigger
                            disabled={window.adobeIMS.isSignedInUser() !== undefined}
                            placement="right"
                            trigger={['hover','focus']}>
                            <span style={{width: '50%'}}>
                                <Radio
                                label="High resolution"
                                checked={this.state.highRes}
                                disabled={window.adobeIMS.isSignedInUser() === undefined}
                                onChange={() => {
                                    this.setState({highRes: true});
                                    this.sendActivationAnalytic('High Resolution');
                                }}/>
                            </span>
                            <Tooltip
                                open
                                className="qaToolTip"
                                placement="right"
                                role="tooltip"
                                variant="inspect">
                                Sign in for best quality
                            </Tooltip>
                        </OverlayTrigger>
                    </div>
                    <div className="saveLib">
                        <OverlayTrigger
                            disabled={window.adobeIMS.isSignedInUser() !== undefined}
                            placement="right"
                            trigger={['hover','focus']}>
                            <span style={{width: '50%'}}>
                                <Checkbox
                                    defaultChecked={false}
                                    disabled={window.adobeIMS.isSignedInUser() === undefined}
                                    label="Save to library"
                                    onChange={() => {
                                        if (!this.state.enableSaveLib) {
                                            this.sendActivationAnalytic('Save to Library');
                                        }
                                        this.setState(prevState => ({
                                        enableSaveLib: !prevState.enableSaveLib,
                                        selectedlib: null,
                                        invalid: false,
                                    }))}}
                                />
                            </span>
                            <Tooltip
                                open
                                className="qaToolTip"
                                placement="right"
                                role="tooltip"
                                variant="inspect">
                                Sign in for Save to Library
                            </Tooltip>
                        </OverlayTrigger>
                        {this.state.enableSaveLib ? <Select
                            menuClassName="qaPopOver"
                            placeholder={!this.state.libsFetched ? "Loading Libraries..." : "Select a library"}
                            options={this.state.libs.map(lib => ({label: lib.name, value: lib}))}
                            disabled={!this.state.libsFetched}
                            onChange={(lib) => {
                                this.setState({selectedlib: lib, invalid: false})
                            }}
                            invalid={this.state.invalid}
                        /> : null}
                    </div>
                    <div className="preview">
                        {this.state.perviewLoaded ? <img src={this.previewUrl}></img> : <div className="loader"><Wait /></div>}
                        <p className="resolution">{String(this.getDownloadImageDimensions()[0]) + "px x " + String(this.getDownloadImageDimensions()[1]) +"px"}</p>
                    </div>
                    {window.adobeIMS.isSignedInUser() === undefined ? <p className="signInMsg">
                        <Link onClick={()=>{
                            window.adobeIMS.signIn();
                            this.sendActivationAnalytic('Sign In');
                            }}>Sign in</Link> to get high resolution and PNG downloads, and to save your patterns to libraries.
                    </p> : null}
                </div>
                <div className="ctas">
                    <Button variant="cta" onClick={() => {
                        this.sendActivationAnalytic('Download');
                        this.handleSave();
                    }}>Download</Button>
                    {window.adobeIMS.isSignedInUser() === undefined ?
                        <Button onClick={() => {
                            window.adobeIMS.signIn();
                            this.sendActivationAnalytic('Sign In');
                            }}>Sign in</Button> : null}
                </div>
            </div>
            <button className="closeDialog" onClick={this.props.onClose}><img src={close} /></button>
            </Dialog></div>
        );
    }
}

export default DownloadCard;
